import { defineMessages } from "react-intl";
export var messages = defineMessages({
  incompleteInput: {
    id: "jutro-components.widgets.inputs.incomplete",
    defaultMessage: "Incomplete input"
  }
});